import React, { useEffect, useRef } from 'react';
import { View, Animated, Dimensions, DimensionValue } from 'react-native';

import { styles } from './styles';

interface SkeletonProps {
  width?: DimensionValue;
  height?: DimensionValue;
  count?: number;
}

const { width: SCREEN_WIDTH, height: SCREEN_HEIGHT } = Dimensions.get('window');

export const Skeleton: React.FC<SkeletonProps> = ({
  width = '100%',
  height = 132,
  count = 1,
}) => {
  const shimmerAnim = useRef(new Animated.Value(0)).current;

  useEffect(() => {
    Animated.loop(
      Animated.timing(shimmerAnim, {
        toValue: 1,
        duration: 1400,
        useNativeDriver: true,
      }),
    ).start();
  }, [shimmerAnim]);

  const translateX = shimmerAnim.interpolate({
    inputRange: [0, 1],
    outputRange: [-SCREEN_WIDTH, SCREEN_WIDTH],
  });

  const translateY = shimmerAnim.interpolate({
    inputRange: [0, 1],
    outputRange: [SCREEN_HEIGHT / 2, -SCREEN_HEIGHT / 2],
  });

  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <View style={{ padding: 12, width: '50%' }} key={index}>
          <View style={[styles.container, { height, width }]}>
            <View style={styles.base} />
            <Animated.View
              style={[
                styles.shimmer,
                {
                  transform: [
                    { translateX },
                    { translateY },
                    { rotate: '20deg' },
                  ],
                },
              ]}
            />
          </View>
        </View>
      ))}
    </>
  );
};
